import styled from 'styled-components';

import { BasicParagraph } from '../../../foundations/typefaces/BasicParagraph';
import style from '../../../style';

export const StyledHeader = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: size.units(4),
  paddingBottom: size.units(2),
  textAlign: 'center',
}));

export const ContentWrapper = styled.div(({ theme: { size } }) => ({
  width: '100%',
  whiteSpace: 'pre-wrap',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: size.units(2),
}));

export const StyledBasicParagraph = styled(BasicParagraph)({
  textAlign: 'center',
});

export const FooterWrapper = styled.div(({ theme: { size } }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'right',
  alignItems: 'center',
  gap: size.units(),
  paddingTop: size.units(4),

  ...style.mixins.responsive.xs.downward({
    width: '100%',
    flexDirection: 'column-reverse',
  }),
}));

export const ImageWrapper = styled.div(({ theme: { size } }) => ({
  height: size.units(7),
}));

export const StyledImage = styled.img({
  height: '100%',
});

interface ButtonWrapperProps {
  $isOnlyButton?: boolean;
}

export const ButtonWrapper = styled.div<ButtonWrapperProps>(
  ({ $isOnlyButton = false }) => ({
    width: $isOnlyButton ? '100%' : '50%',

    ...style.mixins.responsive.xs.downward({
      width: '100%',
    }),
  }),
);
